import { j as C } from "./AccesRecoveryIcon-CUPieIxT.js";
const e = () => /* @__PURE__ */ C.jsxs("svg", { viewBox: "0 0 78 40", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: [
  /* @__PURE__ */ C.jsx(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M65.8868 15.7069C65.6549 13.2594 63.5436 12.4361 60.8769 12.1987L60.8816 8.80423L58.8154 8.80157L58.8109 12.1065C58.2677 12.1059 57.7125 12.1158 57.1609 12.126L57.1658 8.79919L55.1007 8.79624L55.0953 12.1897C54.6479 12.1982 54.2086 12.2059 53.7802 12.2056L53.78 12.1951L50.8986 12.2072L50.9078 14.4043C50.9078 14.4043 52.3494 14.3978 52.4281 14.398C53.265 14.3994 53.5367 14.8856 53.6154 15.305L53.6022 24.6039C53.5651 24.8673 53.4097 25.287 52.825 25.2872C52.8514 25.3107 51.323 25.2847 51.323 25.2847L50.909 27.7517L53.5979 27.7553C54.0982 27.7566 54.5906 27.7658 55.0739 27.7695L55.07 31.2026L57.1339 31.2058L57.1386 27.809C57.7053 27.8216 58.2537 27.8268 58.7891 27.8271L58.7835 31.2082L60.8497 31.2109L60.8551 27.7839C64.329 27.5894 66.7615 26.7177 67.0679 23.4562C67.3153 20.8299 66.0814 19.6561 64.1102 19.1799C65.309 18.5715 66.0595 17.4978 65.8868 15.7069ZM57.1906 25.3106C58.5909 25.3112 62.9834 25.6092 62.9859 23.0436C62.9898 20.3677 58.5982 20.7643 57.1975 20.762L57.1906 25.3106ZM57.2062 14.5545L57.2003 18.6799C57.2975 18.68 57.412 18.682 57.5403 18.6843C58.9517 18.7095 62.0303 18.7645 62.0339 16.6248C62.0367 14.4364 59.0761 14.5107 57.6303 14.5469C57.4676 14.551 57.3241 14.5546 57.2062 14.5545Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ C.jsx(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M58 38.44C68.1841 38.44 76.44 30.1841 76.44 20C76.44 9.81587 68.1841 1.56 58 1.56C47.8159 1.56 39.56 9.81587 39.56 20C39.56 30.1841 47.8159 38.44 58 38.44ZM58 40C69.0457 40 78 31.0457 78 20C78 8.9543 69.0457 0 58 0C46.9543 0 38 8.9543 38 20C38 31.0457 46.9543 40 58 40Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ C.jsx(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M70.4701 30.8053L69.2916 29.7832C71.5655 27.1612 72.94 23.7431 72.94 20C72.94 16.2569 71.5655 12.8388 69.2916 10.2168L70.4701 9.1947C72.9807 12.0895 74.5 15.8673 74.5 20C74.5 24.1327 72.9807 27.9105 70.4701 30.8053ZM68.8053 7.52988L67.7832 8.70841C65.1612 6.4345 61.7431 5.06 58 5.06C54.2569 5.06 50.8388 6.4345 48.2168 8.70841L47.1947 7.52988C50.0895 5.01932 53.8673 3.5 58 3.5C62.1327 3.5 65.9105 5.01932 68.8053 7.52988ZM45.5299 9.1947C43.0193 12.0895 41.5 15.8673 41.5 20C41.5 24.1327 43.0193 27.9104 45.5299 30.8053L46.7084 29.7832C44.4345 27.1612 43.06 23.7431 43.06 20C43.06 16.2569 44.4345 12.8388 46.7084 10.2168L45.5299 9.1947ZM47.1947 32.4701L48.2168 31.2916C50.8388 33.5655 54.2569 34.94 58 34.94C61.7431 34.94 65.1612 33.5655 67.7832 31.2916L68.8053 32.4701C65.9104 34.9807 62.1327 36.5 58 36.5C53.8673 36.5 50.0895 34.9807 47.1947 32.4701Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ C.jsx(
    "path",
    {
      d: "M17.6667 10.0884L6.66675 7.33325C6.6621 9.95057 7.80004 10.9624 12.6667 11.619C16.0848 11.8926 17.4515 12.7487 19.3334 14.9863C20.8261 19.1118 20.7721 21.5254 19.3334 26.0067L13.3334 37.3333C18.2921 35.019 20.333 32.6215 23.0001 27.8435C27.8808 28.2831 29.3054 26.3264 31.0001 21.4149C29.4614 22.5794 28.5515 23.3986 26.6667 23.5577C24.7982 21.9192 24.196 20.905 23.6667 18.0475C23.478 14.4362 24.0012 12.7642 26.6667 12.2312C28.8555 12.2466 31.6667 12.8388 32.3334 12.8388C33.0001 12.8388 33.7459 11.0415 34.0001 10.0884C31.221 10.7188 29.6142 10.8727 26.6667 10.7006L17.6667 10.0884Z",
      fill: "currentColor",
      stroke: "currentColor",
      strokeWidth: "1.5",
      strokeLinejoin: "round"
    }
  ),
  /* @__PURE__ */ C.jsx(
    "ellipse",
    {
      cx: "2.034",
      cy: "3.20907",
      rx: "2.034",
      ry: "3.20907",
      transform: "matrix(0.821648 0.569995 -0.605546 0.79581 22.0664 2)",
      fill: "currentColor",
      stroke: "currentColor",
      strokeWidth: "1.5"
    }
  ),
  /* @__PURE__ */ C.jsx("circle", { cx: "20", cy: "20", r: "19", stroke: "currentColor", strokeWidth: "2" })
] });
export {
  e as F
};
